import {
  GetProgramAccountsFilter,
  LAMPORTS_PER_SOL,
  PublicKey,
} from "@solana/web3.js";
import { getClubs } from "../../../api/clubs.api";
import {
  OFFER_STATUS_OFFSET,
  TREASURY_INDEX,
} from "../../../common/constants/common.constants";
import {
  OfferStatus,
  OfferTypeSolana,
} from "../../../common/enums/proposals.enums";
import { INftListingData } from "../../../common/interfaces/proposals.interface";
import { getTreasuryCount } from "../../../utilities/helpers";
import { getMintMetadata, parseMetadataToNft } from "../../methods/general";
import {
  escrowProgramFactory,
  escrowSeed,
  programFactory,
  treasuryDataSeed,
  treasurySeed,
  unqClubSeed,
} from "../utilities";

export const getAllListings = async () => {
  try {
    const escrowProgram = escrowProgramFactory();
    const clubProgram = programFactory();
    //TODO@goran:use this later
    const filters: GetProgramAccountsFilter[] = [
      {
        memcmp: {
          bytes: OfferStatus.initialised,
          offset: OFFER_STATUS_OFFSET,
        },
      },
    ];
    const allOffers = (await escrowProgram.account.offer.all()).filter(
      (o) =>
        Object.keys(o.account.status)[0] === OfferStatus.initialised &&
        Object.keys(o.account.offerType)[0] === OfferTypeSolana.Sell
    );
    console.log(allOffers);

    const nftListingsData: INftListingData[] = [];
    const allClubs = await getClubs();

    for (const club of Object.keys(allClubs)) {
      const [treasuryAddress] = await PublicKey.findProgramAddress(
        [
          unqClubSeed,
          new PublicKey(club).toBuffer(),
          treasurySeed,
          getTreasuryCount(TREASURY_INDEX),
        ],
        clubProgram.programId
      );
      const relatedOffers = allOffers.filter(
        (o) => o.account.treasury.toString() === treasuryAddress.toString()
      );
      for (const offer of relatedOffers) {
        const [escrowedTokens] = await PublicKey.findProgramAddress(
          [escrowSeed, offer.publicKey.toBuffer()],
          escrowProgram.programId
        );
        try {
          const nftData = await getMintMetadata(offer.account.offeredTokenMint);
          console.log(nftData);

          nftListingsData.push({
            maker: offer.account.maker,
            offer: offer.publicKey,
            offeredAmount: offer.account.offeredAmount.toNumber(),
            wantedAmount: offer.account.wantedAmount.toNumber(),
            relatedClub: allClubs[club],
            escrowedTokenAccount: escrowedTokens,
            nftData,
            wantedMint: offer.account.wantedTokenMint,
          });
        } catch (error) {
          console.log(error);
        }
      }
    }
    return nftListingsData;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getSingleOfferAccount = async (offer: string) => {
  try {
    const offerAddress = new PublicKey(offer);
    const escrowProgram = escrowProgramFactory();
    const offerAccount = await escrowProgram.account.offer.fetch(offerAddress);
    const nftData = await getMintMetadata(offerAccount.offeredTokenMint);
    return {
      price: offerAccount.wantedAmount.toNumber() / LAMPORTS_PER_SOL,
      nftData: parseMetadataToNft(nftData, offerAccount.wantedTokenMint),
      offerPublickey: offerAddress,
      maker: offerAccount.maker,
      nftMint: offerAccount.offeredTokenMint,
    };
  } catch (error) {
    console.log(error);
    throw error;
  }
};
